/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DeleteResult } from '../model/deleteResult';
import { PlatformSubscriptionDto } from '../model/platformSubscriptionDto';
import { PlatformSubscriptionModel } from '../model/platformSubscriptionModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PlatformSubscriptionService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformSubscriptionDeleteDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteResult>;
    public apiPlatformSubscriptionDeleteDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteResult>>;
    public apiPlatformSubscriptionDeleteDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteResult>>;
    public apiPlatformSubscriptionDeleteDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteResult>('delete',`${this.basePath}/api/PlatformSubscription/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param clientAuthId 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformSubscriptionDetailGet(id?: string, clientAuthId?: string, resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<PlatformSubscriptionModel>;
    public apiPlatformSubscriptionDetailGet(id?: string, clientAuthId?: string, resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlatformSubscriptionModel>>;
    public apiPlatformSubscriptionDetailGet(id?: string, clientAuthId?: string, resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlatformSubscriptionModel>>;
    public apiPlatformSubscriptionDetailGet(id?: string, clientAuthId?: string, resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (clientAuthId !== undefined && clientAuthId !== null) {
            queryParameters = queryParameters.set('clientAuthId', <any>clientAuthId);
        }
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('resourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PlatformSubscriptionModel>('get',`${this.basePath}/api/PlatformSubscription/Detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientAuthId 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformSubscriptionDetailsGet(clientAuthId?: string, resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PlatformSubscriptionModel>>;
    public apiPlatformSubscriptionDetailsGet(clientAuthId?: string, resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PlatformSubscriptionModel>>>;
    public apiPlatformSubscriptionDetailsGet(clientAuthId?: string, resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PlatformSubscriptionModel>>>;
    public apiPlatformSubscriptionDetailsGet(clientAuthId?: string, resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientAuthId !== undefined && clientAuthId !== null) {
            queryParameters = queryParameters.set('clientAuthId', <any>clientAuthId);
        }
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('resourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PlatformSubscriptionModel>>('get',`${this.basePath}/api/PlatformSubscription/Details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformSubscriptionInsertPost(body?: PlatformSubscriptionDto, observe?: 'body', reportProgress?: boolean): Observable<PlatformSubscriptionModel>;
    public apiPlatformSubscriptionInsertPost(body?: PlatformSubscriptionDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlatformSubscriptionModel>>;
    public apiPlatformSubscriptionInsertPost(body?: PlatformSubscriptionDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlatformSubscriptionModel>>;
    public apiPlatformSubscriptionInsertPost(body?: PlatformSubscriptionDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PlatformSubscriptionModel>('post',`${this.basePath}/api/PlatformSubscription/insert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformSubscriptionUpdatePut(body?: PlatformSubscriptionModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiPlatformSubscriptionUpdatePut(body?: PlatformSubscriptionModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiPlatformSubscriptionUpdatePut(body?: PlatformSubscriptionModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiPlatformSubscriptionUpdatePut(body?: PlatformSubscriptionModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/PlatformSubscription/update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
